<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users-cog"></i> Tipo de Eventos - Followup</h3>
      </div>
    </div>
    <EventTypeAdd v-if="showAdd" ref="EventTypeAdd" v-on:Back="onBack" />
    <EventTypeList v-else ref="EventTypeList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import EventTypeAdd from './components/add/eventtypeadd.vue'
import EventTypeList from './components/list/eventtypelist.vue'

export default {
  name: 'EventType',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    EventTypeAdd,
    EventTypeList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.EventTypeAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.EventTypeList.onLoad()
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/eventtype/eventtype.vue